const SET_REVIEW_CONSENT = 'rest/model/atg/userprofiling/ProfileActor/setReviewConsent';

export const init = () => {
  const modal = cube.$id('consents-modal');
  const input = cube.$id('review-consent');

  const toggler = cube.$('.dkt-toggler');
  toggler.on('click', (e) => {
    e.preventDefault();
    displayConfirmation(input, modal);
  });

  const consentsModalButton = cube.$id('consents-modal-button');
  consentsModalButton.on('click', () => {
    confirmConsentUpdate(input, modal);
  });

};

/**
 * Display a confirmation modal when user deactivated his reviews publishment
 *
 * @param {HTMLElement} input review consent input
 * @param {HTMLElement} modal confirmation modal
 */
const displayConfirmation = (input, modal) => {
  if (input.checked)
    modal.checked = true;
  else
    updateConsent(input);
};


/**
 * Hide confirmation modal and update user consent
 *
 * @param {HTMLElement} input review consent input
 * @param {HTMLElement} modal confirmation modal
 */
const confirmConsentUpdate = (input, modal) => {
  modal.checked = false;

  updateConsent(input);
};


/**
 * Update user consent related to reviews
 *
 * @param {HTMLElement} input consent input
 */

const updateConsent = input => {
  input.checked = !input.checked;

  const value = input.checked ? 1 : 0;

  cube.ajax
    .post(SET_REVIEW_CONSENT, { value })
    .onSuccess(({ responseTO: { errors } }) => {
      if (errors.length)
        cube.alert.error(errors.map((error) => error.message).join(', '));
      else
        cube.cartridge('my-consent')
          .after(() => {
            cube.alert.success(window.Messages('profile.changesSaved'));
            init();
          })
          .reload();
    })
    .call();
};




// WEBPACK FOOTER //
// ./src/customer/account/account-consent.js